import Player from '@vimeo/player'

export default () => {
  const videos = document.querySelectorAll('.js-vimeo')
  if (!videos.length) return
  ;[...videos].forEach(video => {
    const { id, iframe } = video.dataset
    if (id && iframe) {
      const player = new Player(iframe, {
        id
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/Vimeo.js